// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ao-party {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
  padding: 14px 16px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-xs);
}

.ao-party img,
.ao-party-initials {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
}

.ao-party-initials {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--grad-brand);
  color: #fff;
  font-family: var(--font-display);
  font-size: 0.86rem;
  font-weight: 700;
}

.ao-party-info {
  flex: 1 1;
  min-width: 0;
}

.ao-party-info strong {
  display: block;
  font-family: var(--font-display);
  font-size: 0.98rem;
  color: var(--text);
}

.ao-party-info span {
  font-size: 0.8rem;
  color: var(--muted2);
}

.ao-party-call {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 14px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-pill);
  color: var(--brand);
  font-size: 0.84rem;
  font-weight: 600;
  text-decoration: none;
  transition: border-color 0.2s, background 0.2s;
}

.ao-party-call:hover {
  border-color: var(--brand);
  background: var(--brand-50);
}

.ao-tabs {
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
  padding: 5px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow-x: auto;
}

.ao-tab {
  flex: 1 1;
  min-width: 96px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 12px;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--muted);
  font-family: var(--font-display);
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.ao-tab svg {
  flex-shrink: 0;
}

.ao-tab:hover {
  background: var(--brand-50);
  color: var(--brand);
}

.ao-tab-on {
  background: var(--brand);
  color: #fff;
}

.ao-tab-on:hover {
  background: var(--brand-700);
  color: #fff;
}

.ao-desc {
  margin-top: 8px;
  font-size: 0.89rem;
  line-height: 1.65;
  color: var(--text-soft);
  white-space: pre-wrap;
}

@media (max-width: 560px) {
  .ao-party {
    flex-wrap: wrap;
  }

  .ao-party-call {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/order/AcceptedOrder.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":[".ao-party {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 18px;\n  padding: 14px 16px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-xs);\n}\n\n.ao-party img,\n.ao-party-initials {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.ao-party-initials {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--grad-brand);\n  color: #fff;\n  font-family: var(--font-display);\n  font-size: 0.86rem;\n  font-weight: 700;\n}\n\n.ao-party-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.ao-party-info strong {\n  display: block;\n  font-family: var(--font-display);\n  font-size: 0.98rem;\n  color: var(--text);\n}\n\n.ao-party-info span {\n  font-size: 0.8rem;\n  color: var(--muted2);\n}\n\n.ao-party-call {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 14px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-pill);\n  color: var(--brand);\n  font-size: 0.84rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: border-color 0.2s, background 0.2s;\n}\n\n.ao-party-call:hover {\n  border-color: var(--brand);\n  background: var(--brand-50);\n}\n\n.ao-tabs {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 16px;\n  padding: 5px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  overflow-x: auto;\n}\n\n.ao-tab {\n  flex: 1;\n  min-width: 96px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 10px 12px;\n  border: 0;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--muted);\n  font-family: var(--font-display);\n  font-size: 0.85rem;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n\n.ao-tab svg {\n  flex-shrink: 0;\n}\n\n.ao-tab:hover {\n  background: var(--brand-50);\n  color: var(--brand);\n}\n\n.ao-tab-on {\n  background: var(--brand);\n  color: #fff;\n}\n\n.ao-tab-on:hover {\n  background: var(--brand-700);\n  color: #fff;\n}\n\n.ao-desc {\n  margin-top: 8px;\n  font-size: 0.89rem;\n  line-height: 1.65;\n  color: var(--text-soft);\n  white-space: pre-wrap;\n}\n\n@media (max-width: 560px) {\n  .ao-party {\n    flex-wrap: wrap;\n  }\n\n  .ao-party-call {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
